import React from "react";

interface CheckmarkIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  color?: string;
}

export const WrongCodeIcon: React.FC<CheckmarkIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25195 4.7627L12.7372 13.248"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.7373 4.7522L4.25202 13.2375"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
